// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__A5XFN","header":"ReportDetails_header__wE0gq","title":"ReportDetails_title__34ZO5","left":"ReportDetails_left__2yrAH"};